import { jsxs, jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import ndsTokens from 'nicollet-tokens';
import { Picture } from '../../Picture/index.js';
import { ArrowIcon } from './ArrowIcon.js';

const ArrowContainer = styled.span`
  img,
  svg {
    display: inline-block;
    vertical-align: middle;
    max-width: 20px;
  }
  svg {
    path {
      fill: currentColor;
    }
  }
  margin-left: ${ndsTokens.space.inset.x2};
`;
const SelectBoxArrow = ({
  customLabelImage,
  imageUrl,
  isOpen,
  arrowLabelValue,
  size = 'md'
}) => jsxs(ArrowContainer, Object.assign({
  "aria-expanded": isOpen,
  "aria-label": arrowLabelValue
}, {
  children: [customLabelImage && imageUrl && jsx(Picture, {
    "aria-hidden": "true",
    src: imageUrl
  }, void 0), jsx(ArrowIcon, {
    fillColor: ndsTokens.colors.iconFill.onLight,
    size: size
  }, void 0)]
}), void 0);
SelectBoxArrow.displayName = 'SelectBoxArrow';

export { SelectBoxArrow };
